// Modified transformAbonnementData.js
const transformAbonnementData = (data, lang = 'fr') => {
  return data.result.map((item) => {
    const title = item.title[lang];
    const term = item.duration_subscription[lang];
    const subtitle = item.isPopular 
      ? (lang === 'fr' ? 'LE PLUS POPULAIRE' : 'الأكثر شعبية') 
      : (lang === 'fr' ? 'Abonnement' : 'اشتراك');
    const documentsLabel = lang === 'fr' ? 'Documents' : 'الوثائق';

    return {
      _id: item._id,
      title,
      subtitle,
      price: item.price_ttc.toFixed(3), // Total price
      term,
      plans: [
        `<strong>${item.nbr_doc}</strong> ${documentsLabel}`,
      ],
      popular: item.isPopular ? { isPopular: true } : null,
    };
  });
};

export { transformAbonnementData };